import { useFormik } from "formik";
import BoardButton from "../../../../components/buttons/boardButton";
import TextArea from "../../../../components/inputs/textArea";

const ShowMessage = ({ t, selected }) => {
  const formik = useFormik({ initialValues: {} });
  return (
    <div className="space-y-2 text-black dark:text-white">
      <h2 className="font-semibold">{t("shipmentDetails")}</h2>

      <section className="bg-[#F2F4F6] dark:bg-gray-900 rounded-lg p-4">
        <div className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap">
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("name")}</p>
            <p className="my-2 font-medium">{selected?.customerName}</p>
          </div>
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("email")}</p>
            <p className="my-2 font-medium">mohammed@example.com</p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 md:flex-nowrap">
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("messageType")}</p>
            <p className="my-2 font-medium">{selected?.messageType}</p>
          </div>
          <div className="w-full">
            <p className="text-mainGray dark:text-gray-400">{t("date")}</p>
            <p className="my-2 text-mainBlue">{selected?.date}</p>
          </div>
        </div>
      </section>

      <h2 className="font-semibold">{t("messageText")}</h2>

      <section className="bg-[#F2F4F6] dark:bg-gray-800 rounded-lg p-4">
        <p>
          أود الاستفسار عن أسعار الشحن الدولي من القاهرة إلى دبي لطرد وزنه 5 كيلوجرام.
          هل هناك خصومات للشحنات المتعددة؟
        </p>
      </section>

      <h2 className="font-semibold">{t("reply")}</h2>

      <section>
        <TextArea
          formik={formik}
          name={"reply"}
          className="bg-[#F2F4F6] dark:bg-gray-800 rounded-lg p-4 text-black dark:text-white"
        />
      </section>

      <BoardButton primary bg>
        {t("sendReply")}
      </BoardButton>
    </div>
  );
};

export default ShowMessage;
